import { declareTable } from "util/stdtypes";
import type { Reaction } from "util/stdconfig";

export type ReactionType = {
    label: string;
    emoji: string;
    single?: boolean;
};

export type ConversationHelperConfig = {
    conversationHelperReactionTypes: ReactionType[];
};

export type ThoughtProvokingPrompt = {
    key: string;
    reminder: string;
    suggestedPerspective?: string;
    question?: string;
    explanation?: string;
    time?: number;
};

// eslint-disable-next-line module-data-owner -- FIXME: use module name 'conversationhelpertypes'
export const thoughtProvokingPromptTable = declareTable<ThoughtProvokingPrompt>('thought_provoking_prompt');

// eslint-disable-next-line module-data-owner -- FIXME: use module name 'conversationhelpertypes'
export const thoughtProvokingPromptReactionTable = declareTable<Reaction>('thought_provoking_prompt_reactions');
